var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cta-section"}},[_c('div',{staticClass:"shaddow-cont"}),_c('div',{staticClass:"cta-content"},[_c('div',{staticClass:"cta"},[_c('p',[_vm._v("Do you have a project idea?")]),_c('h2',[_vm._v("Let's Work Together!")]),_c('GetQuote')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }